import {defineAsyncComponent} from 'vue';

import ProductGallerySkeleton from '../skeleton/ProductGallerySkeleton.vue';
import ProductStartersetSkeleton from '../skeleton/ProductStartersetSkeleton.vue';
import ProductRefillsetSkeleton from '../skeleton/ProductRefillsetSkeleton.vue';
import ProductGiftCardSkeleton from '../skeleton/ProductGiftCardSkeleton.vue';

export const ProductsLastViewed = defineAsyncComponent(() => import('./ProductsLastViewed.vue'));
export const ProductRecommendations = defineAsyncComponent(() =>
  import('./ProductRecommendations.vue')
);
export const ProductPicker = defineAsyncComponent(() => import('./ProductPicker.vue'));
export const ProductGalleryTags = defineAsyncComponent(() => import('./ProductGalleryTags.vue'));
export const ProductGallery = defineAsyncComponent({
  loader: () => import('./ProductGallery.vue'),
  loadingComponent: ProductGallerySkeleton,
});
export const ProductStarterset = defineAsyncComponent({
  loader: () => import('./ProductStarterset.vue'),
  loadingComponent: ProductStartersetSkeleton,
});
export const ProductRefillset = defineAsyncComponent({
  loader: () => import('./ProductRefillset.vue'),
  loadingComponent: ProductRefillsetSkeleton,
});
export const ProductGiftCard = defineAsyncComponent({
  loader: () => import('./ProductGiftCard.vue'),
  loadingComponent: ProductGiftCardSkeleton,
});
